import { IFilter } from "@saleor/components/Filter";
import { commonMessages } from "@saleor/intl";
import { FilterOpts } from "@saleor/types";
import { createBooleanField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum CurrencyrateFilterKeys {
  isPrimaryStoreCurrency = "isPrimaryStoreCurrency",
  isPrimaryExchangeRateCurrency = "isPrimaryExchangeRateCurrency",
  isPublished = "isPublished"
}

export interface CurrencyrateListFilterOpts {
  // isPrimaryStoreCurrency: FilterOpts<boolean>;
  // isPrimaryExchangeRateCurrency: FilterOpts<boolean>;
  isPublished: FilterOpts<boolean>;
}

const messages = defineMessages({
  isPrimaryExchangeRateCurrency: {
    defaultMessage: "isPrimaryExchangeRateCurrency",
    description: "isPrimaryExchangeRateCurrency"
  },
  isPrimaryStoreCurrency: {
    defaultMessage: "isPrimaryStoreCurrency",
    description: "isPrimaryStoreCurrency"
  },
  isPublished: {
    defaultMessage: "isPublished",
    description: "isPublished"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: CurrencyrateListFilterOpts
): IFilter<CurrencyrateFilterKeys> {
  return [
    // {
    //   ...createBooleanField(
    //     CurrencyrateFilterKeys.isPrimaryExchangeRateCurrency,
    //     intl.formatMessage(messages.isPrimaryExchangeRateCurrency),
    //     opts.isPrimaryExchangeRateCurrency.value,
    //     {
    //       negative: intl.formatMessage(commonMessages.no),
    //       positive: intl.formatMessage(commonMessages.yes)
    //     }
    //   ),
    //   active: opts.isPrimaryExchangeRateCurrency.active
    // },
    // {
    //   ...createBooleanField(
    //     CurrencyrateFilterKeys.isPrimaryStoreCurrency,
    //     intl.formatMessage(messages.isPrimaryStoreCurrency),
    //     opts.isPrimaryStoreCurrency.value,
    //     {
    //       negative: intl.formatMessage(commonMessages.no),
    //       positive: intl.formatMessage(commonMessages.yes)
    //     }
    //   ),
    //   active: opts.isPrimaryStoreCurrency.active
    // },
    {
      ...createBooleanField(
        CurrencyrateFilterKeys.isPublished,
        intl.formatMessage(messages.isPublished),
        opts.isPublished.value,
        {
          negative: intl.formatMessage(commonMessages.no),
          positive: intl.formatMessage(commonMessages.yes)
        }
      ),
      active: opts.isPublished.active
    }
  ];
}
